import {LitElement, css, html} from "lit";
import {ifDefined} from "lit/directives/if-defined.js";

export class AuiAutosizeInput extends LitElement {

	static get properties() {
		return {
			type: String,
			value: String,
			disabled: { type: Boolean, reflect: true }
		};
	}

	update(changedProperties) {
		super.update(changedProperties);

		this.input.style.width = this._getTextWidth() + "px";
	}

	focus() {
		this.input.focus();
	}

	blur() {
		this.input.blur();
	}

	select() {
		this.input.select();
	}

	_getTextWidth() {
		let newWidth = this.dummy.scrollWidth + 2;

		if(this.type === "number")
			newWidth += 16;

		return newWidth;
	}

	static get styles() {
		return css`
			:host {}
			
			div {
				position: absolute;
				white-space: pre;
				visibility: hidden;
				pointer-events: none;
			}
			
			input {
				background: inherit;
				box-sizing: content-box;
				border: none;
				font-size: inherit;
				outline: none;
				padding: 0;
				color: inherit;
			}
		`;
	}

	get dummy() {
		if(!this._dummy)
			this._dummy = this.shadowRoot.querySelector("div");
		return this._dummy;
	}

	get input() {
		if(!this._input)
			this._input = this.shadowRoot.querySelector("input");
		return this._input;
	}

	render() {
		return html`
			<div>${this.value}</div>
			<input type=${ifDefined(this.type)} @input=${e => this.value = e.target.value} .value=${ifDefined(this.value)} ?disabled=${this.disabled}>
		`;
	}

}

export default AuiAutosizeInput;

customElements.define("aui-autosize-input", AuiAutosizeInput);